import request from "@/api/request";
//获取优惠详情
export function seriesCouponModel() {
  return request({
    url: `/app/seriesCoupon/seriesCouponModel?card=${localStorage.getItem(
      "meCardNum"
    )}`,
  });
}

//获取优惠券列表
export function seriesCouponOrderList() {
  return request({
    url: `/app/seriesCouponOrder/seriesCouponOrderList?card=${localStorage.getItem(
      "meCardNum"
    )}`,
  });
}
